<fin-navigation />

<span class="block">
  <router-outlet />
</span>

<router-outlet name="marketingPreferences" />

<fin-client-only [componentType]="toasterComponentType" />

<fin-client-only [componentType]="cookiePolicyType" />

<fin-client-only [componentType]="chatComponentType" />
<fin-client-only [componentType]="chatGlobalVisibilityComponentType" />

<fin-client-only [componentType]="feedbackWidgetComponentType" />
